import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { AdminService } from "../../../app/service/admin.service";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import MonthWiseGraph from "./MonthWiseGraph";

const CrmDashboardList = () => {
  const [usersData, setUsersData] = useState<any>([]);
  const [monthUsersData, setMonthUsersData] = useState<any>([]);
  const [singleUsersData, setSingleUsersData] = useState<any>([]);
  const loginData: any = sessionStorage.getItem("loginData");
  const data = JSON.parse(loginData);

  useEffect(() => {
    getUsers();
    getMonths();
    getUserMonths();
  }, []);

  const getUsers = () => {
    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();

    AdminService.getTopPerformersByMonth(currentMonth, currentYear).then(
      (res: any) => {
        if (res.status === "Success") {
          const formattedData = res?.data?.map((item: any) => ({
            ...item,
            createdAt: moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
          }));
          setUsersData(formattedData);
        } else {
          toast.error(res.message);
        }
      }
    );
  };

  const getMonths = () => {
    const currentYear = moment().year();

    AdminService.getMonthWiseUserConversions(currentYear).then((res: any) => {
      if (res.status === "Success") {
        setMonthUsersData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const getUserMonths = () => {
    const currentYear = moment().year();
    const userId=data.id

    AdminService.getMonthSingleUserConversions(currentYear,userId).then((res: any) => {
      if (res.status === "Success") {
        setSingleUsersData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };


  return (
    <div>
      <div>
        <div className="container-fluid">
          <div className="row">
            <Header />
          </div>
          <div className="row">
            <div className="col-md-2 h-100 px-0">
              <Sidebar />
            </div>
            <div className="col-md-10 content-scroll content-bg px-3 py-3">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <div
                    className="ourcoursescard px-3 py-5 shadow rounded-4 position-relative"
                    style={{ height: "400px" }}
                  >
                    <h3 className="text-start">
                      Top 5 Performers of
                      <span className="primary-color-two pointer">
                        &nbsp; this month
                      </span>
                    </h3>
                    <table className="table">
                      <thead className="thead-dark">
                        <tr>
                          <th>Name</th>
                          <th>Manager</th>
                          <th>Total Conversions</th>
                          <th>Rank</th>
                        </tr>
                      </thead>
                      <tbody>
                        {usersData?.map((item: any, index: number) => {
                          return (
                            <tr>
                              <td>{item.userName}</td>
                              <td>{item.managerName}</td>
                              <td>{item.totalVerifiedConversations}</td>
                              <td>{item.rank}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-6 mt-3">
                  <div
                    className="shadow rounded-4 p-3"
                    style={{ height: "500px" }}
                  >
                    <h3 className="text-start">Month-wise Conversions</h3>
                    <MonthWiseGraph data={singleUsersData} />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-5"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CrmDashboardList;
